import React, { useState } from "react";
import FooterPanel from "../layout/FooterPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { DocumentPartTreeSelection, TreeViewDataItem } from "../cpm/DocumentPartTree";
import { DocumentPart } from "../../api/models";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { WithApiFileLocationProvider } from "./WithApiFileLocationProvider";
import { fetchDocumentList } from "../../api/document/Location";
import { FileLocation } from "./FileLocationProvider";
import { DocumentLocationExplorer } from "./DocumentLocationExplorer";
import { FlatPathTreeItem } from "../generic/FlatPathTreeExplorer";
import { DocumentOutline } from "./DocumentOutline";
import { ButtonVariants } from "../../styles/fluent/ButtonVariants";

export interface DocumentLinkWrapperState {
  itemSelected: FlatPathTreeItem;
  items: DocumentPart[];
  treeItems: TreeViewDataItem[];
  loaded: boolean;
  isModalOpen: boolean;
  rootPartId: string;

  page: "folders" | "outline" | "export";

  outlineItemSelected: DocumentPartTreeSelection;
}
const initialState: DocumentLinkWrapperState = {
  itemSelected: null,
  items: [],
  treeItems: [],
  loaded: false,
  isModalOpen: false,
  rootPartId: "",
  page: "folders",
  outlineItemSelected: null,
};

interface LinkDocumentProps {
  onLink(partIdToLink: string): any;
}

const LinkExistingDocument: React.FunctionComponent<LinkDocumentProps> = (props) => {
  const [state, setState] = useState<DocumentLinkWrapperState>(initialState);
  const { onLink } = props;

  function onSelectPart(item: FlatPathTreeItem) {
    setState((s) => ({ ...s, itemSelected: item }));
  }

  const handleLinkDocument = async () => {
    onLink(state.outlineItemSelected.key);
  };

  const showOutline = state.itemSelected?.document && !state.itemSelected.document.folder && state.page === "outline";

  const onOutlineItemClick = (selection: DocumentPartTreeSelection) => {
    setState((s) => ({ ...s, outlineItemSelected: selection }));
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          color: "var(--color-grey)",
          fontSize: "14px",
          padding: "5px",
        }}
      >
        {formatMessage("cof.createnewdocument.fromtagetik.info")}
      </div>
      <WithApiFileLocationProvider
        selectDepth="ITEM"
        cleanState={!state.loaded}
        getItems={async (path) => {
          const documentFolder = await fetchDocumentList(path);

          setState((s) => ({ ...s, loaded: true }));

          return documentFolder.map<FileLocation>((df) => {
            return {
              key: df.driveItemId,
              text: df.name.replace(/\.docx$/, ""),
              path: df.path,
              iconName: df.folder ? "fabricFolder" : "wordDocument",
              document: df,
            };
          });
        }}
      >
        {showOutline ? null : (
          <DocumentLocationExplorer
            onSelectItem={onSelectPart}
            documentPartWithStatus={null}
            setDocumentPartWithStatus={() => {}}
          />
        )}
      </WithApiFileLocationProvider>
      {showOutline ? (
        <DocumentOutline selectedTreeItem={state.itemSelected} onItemClick={onOutlineItemClick} isLinkExisting={true} />
      ) : null}
      <FooterPanel>
        <PrimaryButton
          id="outline_button"
          text={
            showOutline
              ? formatMessage("cof.opendocuments.library")
              : formatMessage("cof.documentproperties.viewoutline")
          }
          onClick={() => {
            setState((s) => ({
              ...s,
              page: showOutline ? "folders" : "outline",
              itemSelected: showOutline ? null : state.itemSelected,
              outlineItemSelected: showOutline ? null : s.outlineItemSelected,
            }));
          }}
          disabled={(!showOutline && !state.itemSelected) || state.itemSelected?.document?.folder}
          style={{
            float: showOutline ? "left" : "right",
          }}
          className={showOutline ? ButtonVariants.white : ButtonVariants.blue}
        />
        {showOutline && (
          <PrimaryButton
            id="link_button"
            text={formatMessage("cof.base.link")}
            disabled={
              state.outlineItemSelected?.data?.hasReadPermissions
                ? false
                : state.itemSelected?.document?.id != state.outlineItemSelected?.data?.data?.id
            }
            style={{ float: "right" }}
            onClick={handleLinkDocument}
          />
        )}
      </FooterPanel>
    </>
  );
};

export default LinkExistingDocument;
